<template>
	<div>
		<v-row>
			<v-col cols="4" md="3">
				<div class="form-check form-check-inline">
					<input
						v-model="showDeleted"
						class="form-check-input"
						type="checkbox"
						:value="1"
						false-value=""
					/>
					<label class="form-check-label"
					>Archived</label
					>
				</div>
			</v-col>
		</v-row>
		<bw-table
			aria-label="data-table"
			:headers="headers"
			hide-search
			hide-row-select
			:items="filteredLists"
	>
		<template v-slot:item.name="{ item: messageList }">
			<div
					class="text-subtitle-2"
					style="flex-wrap: nowrap !important;"
			>
				{{ messageList.name }}
			</div>
		</template>
		<template v-slot:item.created_at="{ item: messageList }">
			{{ moment(messageList.created_at).format('L') }}
		</template>
		<template v-slot:item.actions="{ item: messageList }">
			<div class="d-flex justify-end">
				<v-btn
						v-if="messageList.is_external"
						color="secondary"
						depressed
						fab
						:href="editMessageList(messageList)"
						outlined
						small
				>
					<v-icon>
						mdi-pencil-outline
					</v-icon>
				</v-btn>
				<v-divider
						class="mx-2 my-1"
						vertical
				></v-divider>
				<v-btn
						color="accent"
						depressed
						fab
						:href="viewMessageList(messageList)"
						outlined
						small
				>
					<v-icon>
						mdi-clipboard-text-search
					</v-icon>
				</v-btn>
			</div>
		</template>
	</bw-table>
	</div>
</template>

<script>
export default {
	name: 'ListMessageLists',
	props: {
		messageLists: {
			type: Array,
			default: () => []
		},
		partner: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			headers: [
				{
					align: 'start',
					filterable: false,
					text: 'ID',
					value: 'id',
					width: '1%'
				},
				{
					align: 'start',
					mandatory: true,
					text: 'Message List',
					value: 'name'
				},
				{
					align: 'start',
					mandatory: true,
					text: 'Created Date',
					value: 'created_at',
					width: '1%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Actions',
					value: 'actions',
					width: '1%'
				}
			],
			showDeleted: false,
		};
	},
	computed: {
		avatarSize() {
			if(this.$vuetify.breakpoint.xsOnly) return 36;
			if(this.$vuetify.breakpoint.smOnly) return 40;
			if(this.$vuetify.breakpoint.mdOnly) return 44;
			return 48;
		},
		filteredLists() {
			return this.messageLists.filter(list => {
				if (this.showDeleted) {
					return true;
				}
				return !list.deleted;
			});
		}
	},
	created() {
	},
	methods: {
		editMessageList(messageList) {
			return `/partner-portal/${this.partner.id}/message-lists/edit-message-lists/${messageList.id}`;
		},
		viewMessageList(messageList) {
			return `/partner-portal/${this.partner.id}/message-lists/view-message-lists/${messageList.id}`;
		}
	}
};
</script>

<style lang="scss" scoped></style>
